import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';

import IZoningCode = ZoningAPI.IZoningCode;

import { ZoningCodeService } from '../../../services/zoning-code.service';
import { InstanceService } from '../../../services/instance.service';

@Component({
    standalone: false,
    selector: 'app-zoning-code-dialog',
    templateUrl: './zoning-code-dialog.component.html',
    styleUrls: ['./zoning-code-dialog.component.scss']
})
export class ZoningCodeDialogComponent implements OnInit {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private readonly zoningCodeService: ZoningCodeService,
        private readonly instanceService: InstanceService
    ) {
        this.zoningCodes = this.zoningCodeService.newZoningCodes;
    }

    public zoningCodes: Observable<IZoningCode[]>;
    public selectedZoningCode: IZoningCode;

    ngOnInit() {
        this.zoningCodeService.getNewZoningCodes(this.instanceService.selectedInstance);
    }
}
